export class WebUtils {
  static isWeb() {
    return window.location.hostname.includes('estudaqui.com')  ;
  }
}
